import heroMobile from '../../assets/images/hero-mobile.jpg';

const MobileHero = () => {
    return (
        <section className="md:hidden h-72 sm:h-[30rem] bg-custom-bg-hero mt-4 rounded-lg overflow-hidden">
            <img src={heroMobile} alt="" className="w-full h-full object-contain" />
        </section>
    );
};

export default MobileHero;
